<template>
  <div id="materialUseStatistics">
    <div class="filterConditionContainer">
      <el-card class="box-card">
        <div class="filterCondition" >
          <div class="searchIcon">
            <i class="el-icon-search"></i>
          </div>
          <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
            <el-form-item :label="$t('filters.region')" >
              <el-select v-model="filterForm.regionNo" multiple :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()">
                <el-option
                  v-for="item in regionOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('filters.reseller')" >
              <el-select v-model="filterForm.resellerNo" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
                <el-option
                  v-for="item in resellerOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.storeType')" >
              <el-select v-model="filterForm.storeType" :placeholder="$t('filters.chooseStoreType')">
                <el-option
                  v-for="item in storeTypeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.doorName')"  >
            <span @click="onChooseDoor">
              <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
            </span>
            </el-form-item>
            <el-form-item label="门店编号">
              <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('filters.publicAccountType')" >
              <el-select v-model="filterForm.publicAccountType" :placeholder="$t('filters.choosePublicAccountType')">
                <el-option
                  v-for="item in publicAccountTypeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.publicAccountName')" >
              <el-input v-model="filterForm.publicAccountName" :placeholder="$t('filters.enterPublicAccountName')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('materialUseStatistics.customTimeScope')" >
              <el-date-picker
                v-model="filterForm.timeScope"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="-"
                :start-placeholder="$t('survey.startTime')"
                :end-placeholder="$t('survey.endTime')"
                align="right">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <div class="filterBtns">
                <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="filterBtns filterBtnsRight">
                <el-button type="primary" @click="exportData()">{{ $t('export') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
    </div>
    <div class="tableContainer">
      <el-card class="box-card">
        <div class="tableBox">
          <div class="orangeIcon">
            <i class="el-icon-s-order"></i>
          </div>
        </div>
        <div style="margin-top: 20px">
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="regionName"
              :label="$t('filters.region')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="resellerName"
              :label="$t('filters.reseller')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="storeType"
              :label="$t('filters.storeType')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="doorName"
              :label="$t('store.doorName1')"
              width="280">
            </el-table-column>
            <el-table-column
              prop="posId"
              label="门店编号"
              width="120">
            </el-table-column>
            <el-table-column
              prop="publicAccountType"
              :label="$t('filters.publicAccountType')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="publicAccountName"
              :label="$t('filters.publicAccountName')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="recentPushTime"
              :label="$t('materialUseStatistics.recentPushTime')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="fansAmount"
              :label="$t('materialUseStatistics.fansAmount')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="twoWeekUse"
              :label="$t('materialUseStatistics.twoWeekUse')"
              width="140">
            </el-table-column>
            <el-table-column
              prop="twoWeekUnUse"
              :label="$t('materialUseStatistics.twoWeekUnUse')"
              width="150">
            </el-table-column>
            <el-table-column
              prop="monthUseAmount"
              :label="$t('materialUseStatistics.monthUseAmount')"
              width="140">
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('operation')"
              width="120">
              <template slot-scope="scope">
                <el-button @click="exportData(scope.row)" type="text" size="small">{{ $t('newSurvey.exportData') }}</el-button>
                <router-link :to=" { path:'/wo/materialUseStatisticsDetail', query: { id: scope.row.id, doorName: scope.row.doorName } }" target="_blank">
                  <el-button type="text" size="small">{{ $t('more') }}</el-button>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagingBox">
            <el-pagination
              background
              @current-change="currentChange"
              :current-page="tableConfig.current"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Cookies from 'js-cookie'
import PickDoor from '../../components/pickDoor'
export default {
  name: 'MaterialUseStatistics',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '当天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近两周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近两个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      storeTypeOptions: [], // 门店类型
      publicAccountTypeOptions: [], // 公众号类型
      regionOptions: [],
      resellerOptions: [],
      dialogTableVisible: false,
      initFilterForm: {
        regionNo: '', // 区域
        resellerNo: '', // 客户
        posId: '', // posId
        door: '', // 门店名
        publicAccountType: '', // 公众号类型
        storeType: '', // 门店类型
        publicAccountName: '', // 公众号名称
        timeScope: '', // 时间段
      },
      filterForm: {},
      tableData: [],
      tableConfig: {
        current: 1,
        size: 10
      },
      total: 0
    }
  },
  mounted () {
    this.onReset()
    this.getRangeList()
  },
  computed: {
  },
  methods: {
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'resellerNo': this.filterForm.resellerNo,
        'regionNo': this.filterForm.regionNo,
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailogUrl + '/account/common', submitParams)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = res.regionList
      this.resellerOptions = res.resellerList
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      const params = this.$tool.formatArrayToString(this.filterForm)
      let res = await this.$api.survey_api.listDoor(_.assign(params, this.tableConfig))
      this.tableData = res.list
      this.total = res.total
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
      this.getRangeList(true)
    },

    exportData: async function () {
      let { data, fileName } = await this.$tool.exportFile({
        method: 'post',
        url: this.$api.survey_api.base  + '/door/export',
        data: this.$tool.formatArrayToString(this.filterForm)
      })
      console.log(data, fileName)
    },

    currentChange: function (index) {
      this.tableConfig.current = index
      this.onSearch(false)
    },
  }
}
</script>

<style lang="sass" scoped>
  a
    margin-left: 10px
  .filterConditionContainer
    margin: 40px 20px 20px 20px
  .tableContainer
    margin: 40px 20px
  input[type=file]
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/wo/materialUseStatistics.vue